import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getStory, removeStory } from 'slice/storySlice';
import AdminTable from 'common/AdminTable';
import { useNavigate } from 'react-router-dom';

const List = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { list: storyList } = useSelector((state) => state.story || {});

  useEffect(() => {
    dispatch(getStory());
  }, [dispatch]);

  const handleRemove = (id) => {
    if (!window.confirm('Delete this story?')) return;
    dispatch(removeStory(id));
  };

  const tableHeaders = [
    { Header: 'ID', accessor: 'id' },
    { Header: 'Heading', accessor: 'heading' },
    { Header: 'Category', accessor: 'category' },
    {
      Header: 'Image',
      accessor: 'image',
      Cell: ({ row }) =>
        row.original.image ? (
          <img
            src={`${process.env.REACT_APP_BACKEND}uploads/stories/${row.original.image}`}
            alt={row.original.heading || 'Story'}
            width={100}
          />
        ) : (
          'No Image'
        )
    },
    {
      Header: 'Extra Images',
      accessor: 'images',
      Cell: ({ row }) => {
        const images = row.original.images;
        return Array.isArray(images) ? images.length : 0;
      }
    },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ({ row }) => (
        <>
          <button className="btn btn-danger mx-1" onClick={() => handleRemove(row.original.id)}>
            Remove
          </button>
          <button className="btn btn-primary mx-1" onClick={() => navigate(`/story/update/${row.original.id}`)}>
            Edit
          </button>
        </>
      )
    }
  ];

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Story List</h4>
      </div>

      {storyList?.length > 0 ? (
        <AdminTable tableHeaders={tableHeaders} tableData={storyList} />
      ) : (
        <p className="text-white mx-4 mt-3">No stories found.</p>
      )}
    </div>
  );
};

export default List;
